export interface DraftItem {
  description: string;
  source?: "manual" | "ai";
}

export const emptyDraftItem = (): DraftItem => ({
  description: "",
  source: "manual",
});

export interface ShippingAddressDraft {
  line1: string;
  line2: string;
  postalCode: string;
  city: string;
  country: string;
}

export const emptyShippingAddress = (): ShippingAddressDraft => ({
  line1: "",
  line2: "",
  postalCode: "",
  city: "",
  country: "NO",
});

export interface StepCompletion {
  contact: boolean;
  items: boolean;
  stones: boolean;
  terms: boolean;
}

export function isStepComplete(index: number, completion: StepCompletion, activeStep: number) {
  if (index === 0) return completion.contact;
  if (index === 1) return completion.items;
  // The stones step is valid before the customer has seen it — NONE_OR_KEEP is the default — so a
  // tick there would claim a decision nobody made. It counts once the customer has moved past it.
  if (index === 2) return completion.stones && activeStep > 2;
  return completion.contact && completion.items && completion.stones && completion.terms;
}
